import axios from "axios";

export const getLink = async (bannerId, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getLink/${bannerId}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
